import React, { useContext } from 'react';
import styled from 'styled-components';
import Link from '~/components/link';
import { getBlogListThumb } from '~/components/blog/blogImages';
import Countries from '~/components/countries_enum.ts';
import { LangContext } from '~/providers/LangProvider';
import { countryCodesBlog } from '~/providers/LangProvider/langUtils';

const BlogItem = ({ post, country }) => {
    const ctxLang = useContext(LangContext);
    let articleUrl = `/${ctxLang.state.lang}/${countryCodesBlog[country]}/blog/${post.slug}`;

    return (
        <BlogLink href={articleUrl}>
            <BlogItemContainer>
                <BlogItemThumbnail
                    src={getBlogListThumb(post.image.src)}
                    alt={post.title}
                />
                <TextWrapper>
                    <BlogItemTitle>{post.title}</BlogItemTitle>
                    <BlogItemPerex dangerouslySetInnerHTML={{ __html: post.perex }} />
                </TextWrapper>
            </BlogItemContainer>
        </BlogLink>
    );
};

export default BlogItem;

const BlogItemContainer = styled.div`
    max-width: 286px;
    min-width: 250px;
    box-shadow: 6px 6px 14px rgba(0, 0, 0, 0.06);
    border-radius: 5px;
    border: 1px solid #f1efef;
    background-color: white;
    margin: 2rem 1.25rem 1.25rem 1.25rem;
    border-radius: 8px;
    transition: 0.25s ease-in-out transform, 0.25s ease-in-out box-shadow;

    &:hover {
        -webkit-transform: translateY(-5px);
        transform: translateY(-5px);
        box-shadow: 0 20px 60px -10px rgba(41, 39, 44, 0.3);
    }

    /* Overwriting global <a> tag styles for this component */
    a {
        text-decoration: none;

        &:hover {
            text-decoration: none;
        }
    }
`;

const BlogItemThumbnail = styled.img`
    width: 100%;
    height: auto;
    max-width: 286px;

    cursor: pointer;
    border-top-right-radius: 8px;
    border-top-left-radius: 8px;
`;

const BlogItemTitle = styled.h2`
    font-weight: bold;
    font-size: 18px;
    line-height: 26px;
    text-decoration-line: underline;
    color: #0cc8a8;
    margin: 1.6rem 0 0.8rem 0;
    cursor: pointer;
`;

const BlogItemPerex = styled.p`
    font-style: normal;
    font-weight: normal;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.02em;
    color: #6a6a6a;
    margin-bottom: 0px;
    overflow: hidden;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
`;

const TextWrapper = styled.div`
    padding: 0 32px 32px 32px;
`;

const BlogLink = styled.a`
    text-decoration: none;
    display: flex;
    flex-wrap: wrap;
    &:hover {
        text-decoration: none;
    }
`;
